<template>
  <div class="animated fadeIn" id="list-inscriptions">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-search mr-2"></i>
          <strong>Recherche</strong>
          <div class="card-header-actions">
            <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </b-link>
          </div>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-form v-on:submit.prevent="searchByFilters">
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="is_register"><strong>Bénéficiaires de rentes</strong></label>
                    <!-- Il s'agit de la colonne "is_register" de la table login, indiquant si le bénéficiaire a choisi d'être contacté ou non  -->
                    <b-form-radio-group id="is_register" v-model="is_register">
                      <b-form-radio value="">Tous</b-form-radio>
                      <b-form-radio value="true">Inscrits</b-form-radio>
                      <b-form-radio value="false">Non inscrits</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="is_active"><strong>Etat du bénéficiaire</strong></label>
                    <!-- Il s'agit de la colonne "is_active" de la table users, indiquant si le bénéficiaire est considéré comme décédé ou non  -->
                    <b-form-radio-group id="is_active" v-model="is_active" name="is_active">
                      <b-form-radio value="tous">Tous</b-form-radio>
                      <b-form-radio value="false">Inactif <span id="is_active-tooltip" class="ml-1" @click.prevent=""><i
                        class="fa fa-question-circle orange-question"></i></span></b-form-radio>
                      <b-form-radio value="true">Actif</b-form-radio>
                    </b-form-radio-group>
                    <b-tooltip target="is_active-tooltip" placement="top">Bénéficiaires n'ayant pas reçu de décompte
                      depuis plus de 6 mois.
                    </b-tooltip>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="is_mailable"><strong>Accord Communication</strong></label>
                    <!-- Il s'agit de la colonne "is_mailable" de la table login, indiquant si le bénéficiaire a choisi d'être contacté ou non  -->
                    <b-form-radio-group id="is_mailable" v-model="is_mailable">
                      <b-form-radio value="">Tous</b-form-radio>
                      <b-form-radio value="true">Oui</b-form-radio>
                      <b-form-radio value="false">Non</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="num_nsi"><strong>N°Identifiant NSI</strong></label>
                    <b-form-input type="text" id="num_nsi" v-model="num_nsi"
                                  :class="{hasError: errors.num_nsi !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.num_nsi }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="num_dossier"><strong>N° Dossier</strong></label>
                    <b-form-input type="text" id="num_dossier" v-model="num_dossier"
                                  :class="{hasError: errors.num_dossier !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.num_dossier }}</span>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="nir"><strong>N° Sécurité Sociale</strong></label>
                    <b-form-input type="text" id="nir" v-model="nir"
                                  :class="{hasError: errors.nir !== ''}"></b-form-input>
                    <span class="field-error">{{ errors.nir }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="nom"><strong>Nom</strong></label>
                    <b-form-input type="text" id="nom" v-model="nom"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="prenom"><strong>Prénom</strong></label>
                    <b-form-input type="text" id="prenom" v-model="prenom"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="email"><strong>Email</strong></label>
                    <b-form-input type="text" id="email" v-model="email"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-1">
                  <i class="fa fa-eraser"></i> Effacer
                </b-button>
                <b-button type="enter" @click="searchByFilters" size="md" variant="primary">
                  <i class="fa fa-search"></i> Rechercher
                </b-button>
              </div>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>

    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des Inscriptions</strong>
      </b-card-header>
      <b-card-body>
        <inscription-table :tableEntry="tableParam" ref="inscription_table"></inscription-table>
      </b-card-body>
      <div slot="footer">
        <vue-excel-xlsx
          v-show="false"
          ref="excel"
          :data="excelData"
          :columns="excelColumns"
          filename="export_login">
        </vue-excel-xlsx>
        <b-button type="enter" @click="triggerExport" size="md" variant="primary" class="btn btn-success mr-1 pull-right">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </b-button>

      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../utils/auth";
  import InscriptionTable from '../../components/InscriptionTable'

  export default {
    components: {InscriptionTable},
    data() {
      return {
        columns: [
          "date_creation",
          "nsi",
          "nir",
          "nom",
          "prenom",
          "email",
          "telephone",
          "type_rente",
          "statut"
        ],
        items: [],
        options: {
          headings: {
            nsi: "N°Ident. NSI",
            nir: "N° Sécu. Soc.",
            nom: "Nom",
            prenom: "Prénom",
            email: "Email",
            telephone: "Téléphone",
            date_creation: "Date de création",
            statut: "Actif",
            type_rente: "Type de rente",
            action: "#"
          },
          sortable: ["nsi", "nom"],
          filterable: ["nsi", "email"],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "N°Identifiant NSI, Email"
          }
        },
        num_nsi: '',
        nir: '',
        num_dossier: '',
        nom: '',
        prenom: '',
        email: '',
        is_active: 'tous',
        is_mailable: '',
        is_register: '',
        errors: {num_nsi: '', num_dossier: '', nir: '', nom: '', email: ''},
        excelColumns: [
          {
            label: "NSI",
            field: "nsi",
          },
          {
            label: "Nom",
            field: "nom",
          },
          {
            label: "Prénom",
            field: "prenom",
          },
          {
            label: "Email",
            field: "email",
          },
          {
            label: "Téléphone",
            field: "telephone",
          },
          {
            label: "Date de création",
            field: "date_creation",
          },
          {
            label: "Compte Activé",
            field: "statut",
          },
          {
            label: "Accord communication",
            field: "communication",
          },
          {
            label: "Bénéf. Actif",
            field: "is_active",
          },
          {
            label: "Type de rente",
            field: "type_rente",
          },
          {
            label: "SIRET",
            field: "siret",
          },
          {
            label: "Produit dc",
            field: "produit_dc",
          },
          {
            label: "Produit inval",
            field: "produit_inval",
          }
        ],
        excelData: [],
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    computed: {
      tableParam: {
        get() {
          let request = {};

          request.num_nsi = this.num_nsi.replace(/ /g, "")
          this.num_nsi = request.num_nsi
          request.num_dossier = this.num_dossier.replace(/ /g, "")
          this.num_dossier = request.num_dossier
          request.nir = this.nir.replace(/ /g, "")
          this.nir = request.nir
          request.nom = this.nom;
          request.prenom = this.prenom;
          request.email = this.email;
          request.is_mailable = this.is_mailable;
          request.is_active = this.is_active;
          request.is_register = this.is_register;

          return request;
        }
      },
      classObject: function () {
        return {
          'btn-disable': !this.excelData.length > 0,
        }
      }
    },
    methods: {
      all() {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        let request = {}

        this.$axios
          .get('/espaceBeneficiaire/inscriptions/recherche', request)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.users;
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Un problème est survenu, merci de contacter le support",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      searchByFilters() {
        if (this.validateData()) {
          // console.log('refresh')
          this.$refs.inscription_table.$refs.table.refresh()
        }
      },
      validateData() {
        this.clearErrors()
        let regNumeric = this.$store.getters.getRegNumeric
        let valid = true

        let num_nsi = this.num_nsi.replace(/ /g, "")
        if (num_nsi !== '') {
          if (!regNumeric.test(num_nsi)) {
            this.errors.num_nsi = 'Un N°Identifiant NSI ne doit contenir que des chiffres'
            valid = false
          } else if (num_nsi.length > 9 || num_nsi.length < 9) {
            this.errors.num_nsi = 'Un N°Identifiant NSI doit contenir exactement 9 chiffres'
            valid = false
          }
        }
        let num_dossier = this.num_dossier.replace(/ /g, "")
        if (num_dossier !== '') {
          if (!regNumeric.test(num_dossier)) {
            this.errors.num_dossier = 'Un N° Dossier ne doit contenir que des chiffres'
            valid = false
          }
        }
        let nir = this.nir.replace(/ /g, "")
        if (nir !== '') {
          if (!regNumeric.test(nir)) {
            this.errors.nir = 'Un N°Identifiant NSI ne doit contenir que des chiffres'
            valid = false
          } else if (nir.length > 13 || nir.length < 13) {
            this.errors.nir = 'Un N° de Sécurité Sociale doit contenir exactement 13 chiffres'
            valid = false
          }
        }
        return valid
      },
      clearErrors() {
        this.errors.num_nsi = ''
        this.errors.nir = ''
        this.errors.num_dossier = ''
      },
      formatNir(textNir) {
        if (textNir !== null && textNir !== '') {
          if (textNir.length > 13) {
            return textNir.substring(0, 13)
          }
        } else {
          return textNir;
        }
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      clearForm() {
        this.num_nsi = ''
        this.num_dossier = ''
        this.nir = ''
        this.nom = ''
        this.prenom = ''
        this.email = ''
        this.is_mailable = ''
        this.is_active = 'tous'
        this.is_register = ''
      },
      triggerExport() {
        let self = this
        this.excelData = [];
        // console.log('triggerExport')
        let request = {};
        request.num_nsi = this.num_nsi.replace(/ /g, "")
        this.num_nsi = request.num_nsi
        request.num_dossier = this.num_dossier.replace(/ /g, "")
        this.num_dossier = request.num_dossier
        request.nir = this.nir.replace(/ /g, "")
        this.nir = request.nir
        request.nom = this.nom;
        request.prenom = this.prenom;
        request.email = this.email;
        request.is_mailable = this.is_mailable;
        request.is_active = this.is_active;
        request.is_register = this.is_register;

        this.$store.commit("IS_LOADING", true);

        this.$axios.post("/espaceBeneficiaire/inscriptions/export", request)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            for (let item of response.data.users.data) {
              this.excelData.push({
                nsi: item.nsi,
                nom: item.nom,
                prenom: item.prenom,
                email: item.email,
                telephone: item.telephone,
                date_creation: this.formatDate(item.date_creation),
                statut: item.statut === true ? 'Oui' : 'Non',
                type_rente: item.type_rente,
                communication: item.communication === true ? 'Oui' : 'Non',
                is_active: item.is_active === true ? 'Oui' : 'Non',
                siret: item.siret,
                produit_dc: item.produit_dc,
                produit_inval: item.produit_inval,
              });
            }
            if(this.excelData.length > 0) {
              this.$refs.excel.$el.click();
            }
          })
          .catch(function (error) {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Un problème est survenu, merci de contacter le support",
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    }
  };
</script>
<style scoped>
  .btn-disable {
    cursor: not-allowed;
    pointer-events: none;
    color: #c0c0c0;
    background-color: #ffffff;
  }
</style>
